import { defineStore } from 'pinia';

interface Alert {
    message: string;
    type: string;
}

export const useAlertStore = defineStore('Alert',{
    state: (): { alert: Alert | null } => ({
        alert: null
    }),
    actions: {
        success: function(this: any, message: string): void {
            this.alert = { message, type: 'success' };
        },
        error: function(this: any, message: string): void {
            this.alert = { message, type: 'error' };
            console.log(this.alert);
        },
        clear: function(this: any): void {
            this.alert = null;
        }
    }
});


/******* mudar */